import React, { useState, useEffect, useCallback } from "react";
import useStyles from "./style";
import { Grid, Typography, TextField, Button, IconButton, InputAdornment } from "@mui/material";
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useDropzone } from "react-dropzone";
import { useFormik } from "formik";
import * as yup from "yup";
import fileUploadApi from "Services/ImageUpload";
import settingsApi from "Services/Settings";
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { triggerHeaderProfile } from "Redux/ProfileSettings/actions";
import { API_ENDPOINTS } from "Constants";

const ProfileSettings = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const triggerHeaderState = useSelector(
    (state) => state?.ProfileSettingsReducer?.triggerHeader
  );

  const [profileDetails, setProfileDetails] = useState(null);
  const [userId, setuserId] = useState("")

  // Upload admin profile image;
  const uploadProfileImage = (acceptedFiles) => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Profile image uploaded successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        //console.log("res.data--->",res?.data?.data?.image)
        formik1.setFieldValue("adminImage", res?.data?.data?.image);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.msg || "Error while upload image",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      //console.log("profile image upload api", err);
    };
    const formData = new FormData();
    //console.log("acceptedFiles-->",acceptedFiles);
    // acceptedFiles?.map((file) => formData.append("file", file));
    acceptedFiles.forEach((file) => {
      formData.append("image", file); // Append the file
    });
    formData.append("userId", profileDetails._id); // Append the userId to FormData
    
    fileUploadApi.profileimageupload(formData).then(onSuccess, onFailure);
  };

  // Max file size
  const maxFileSize = 5242880;
  const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };
  // File length validator
  const fileLengthValidator = (file) => {
    if (file.size > maxFileSize) {
      alert(`File size is larger than ${formatBytes(maxFileSize)}`);
      return {
        code: "file-too-large",
        message: `File size is larger than ${formatBytes(maxFileSize)}`,
      };
    }
    return null;
  };
  // Dropzone props
  const { getRootProps, getInputProps, open } = useDropzone({
    noClick: true,
    noKeyboard: true,
    maxSize: maxFileSize, // Use raw maxFileSize, not formatted value
    maxFiles: 1,
    accept: "image/*", // Valid MIME types
    validator: fileLengthValidator,
    onDrop: (acceptedFiles) => {
      let fileLength = acceptedFiles.map((file) => file.size);
      if (acceptedFiles && fileLength < maxFileSize) {
        //console.log('acceptedFiles-->', acceptedFiles);
        uploadProfileImage(acceptedFiles);
      }
    },
  });

  // Save or Edit profile details
  const handleBasicInfo = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    const data = {
      user_name: formValues?.name,
      email: formValues?.email,
      mobile: formValues?.mobileNo,
      userID: userId
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "User details updated successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        setProfileDetails([]);
        formik1.resetForm();
        getProfileDetails();
        dispatch(triggerHeaderProfile(!triggerHeaderState));
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while update user details",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update profile details api", err);
    };
    settingsApi.updateProfileDetails({ ...data }).then(onSuccess, onFailure);
  };

  const formik1 = useFormik({
    initialValues: {
      adminImage: "",
      name: "",
      email: "",
      mobileNo: "",
      userID:"",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      adminImage: yup.string().nullable(),
      name: yup
        .string()
        .required("Name is required")
        .max(30, "Max 30 characters")
        .trim()
        .nullable(),
      email: yup.string().email("Enter valid email").nullable(),
      mobileNo: yup
        .string()
        .required("Mobile number is required")
        .matches(/^[0-9]+$/, "Only Numbers are allowed")
        .max(10, `Max 10 digits are allowed`)
        .min(10, `Must be exactly 10 numbers`)
        .nullable(),
    }),
    onSubmit: handleBasicInfo,
  });

  // Update Password
  const handlePassword = (formValues) => {
    dispatch(showLoader("Loading please wait..."));
    //console.log("formValues-->",formValues);
    const data = {
      newPassword: formValues?.confirmPassword,
      userID: userId
    };
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Updated password successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik2?.resetForm();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.msg || "Error while update password",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      //console.log("update password api", err);
    };

    settingsApi.updatePassword({ ...data }).then(onSuccess, onFailure);
  };

  const formik2 = useFormik({
    initialValues: {
      newPassword: "",
      confirmPassword: "",
    },
    enableReinitialize: true,
    validationSchema: yup.object({
      newPassword: yup.string().required("New password is required"),
      confirmPassword: yup
        .string()
        .required("Confirm password is required")
        .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
    }),
    onSubmit: handlePassword,
  });
  
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleToggleNewPasswordVisibility = () => {
    setShowNewPassword((prev) => !prev);
  };

  const handleToggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  // Get profile details api
  const getProfileDetails = useCallback(() => {
    dispatch(showLoader("Loading please wait..."));
    const onSuccess = (res) => {
      dispatch(hideLoader());
      //console.log('res.data.status-->',res.data.status);
      if (res?.data?.status === true) {
        //console.log("res?.data?.data-->",res?.data?.data);
        setProfileDetails(res?.data?.data);
      } else {
        setProfileDetails([]);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      showSnackbar({
        message: err?.data?.message || "Failed to fetch the data",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      });
      //console.log("Get profile details Api", err);
    };
    settingsApi.getProfileDetails({}).then(onSuccess, onFailure);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getProfileDetails();
  }, [getProfileDetails]);

  // Set profile values for edit
  useEffect(() => {
    if (!_.isEmpty(profileDetails)) {
      if (
        profileDetails?.image !== null ||
        profileDetails?.image !== "" ||
        profileDetails?.image !== "undefined"
      ) {
        formik1.setFieldValue("adminImage", profileDetails?.image);
      }
      formik1.setFieldValue("name", profileDetails?.user_name);
      formik1.setFieldValue("email", profileDetails?.email);
      formik1.setFieldValue("mobileNo", profileDetails?.mobileNumber);
      setuserId(profileDetails?._id);
      formik2.setFieldValue("newPassword", "");
      formik2.setFieldValue("confirmPassword", "");
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [profileDetails]);

  return (
    <>    
      <Grid container>
        {/* <section className={classes.container}> */}
        <Grid item xs={12}>
          <section className={classes.avatarContainer}>
            <div className={classes.avatarWrapper}>
              <div className={classes.avatar}>
                <img
                  src={
                    !_.isEmpty(formik1?.values?.adminImage)
                      ? `${formik1?.values?.adminImage}`
                      : "/assets/images/user/avatar.png"
                  }
                  alt="avatar"
                  className={classes.img}
                />
                <section
                  {...getRootProps()}
                  onClick={open}
                  className={classes.editIcon}
                >
                  <input  {...getInputProps()} />
                  <CameraAltOutlinedIcon />
                </section>
              </div>
            </div>
          </section>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.container}>
            <div className={classes.heading}>
              <Typography variant="h5">Basic information</Typography>
            </div>
            <div className={classes.fieldContainer}>
              <Grid item xs={12} sm={6}>
                <div className={classes.rightMargin}>
                  <TextField
                    name="name"
                    id="name"
                    value={formik1?.values?.name}
                    onChange={formik1?.handleChange}
                    type={"text"}
                    fullWidth
                    variant="outlined"
                    size="small"
                    label="Name*"
                    error={formik1?.errors?.name && formik1?.touched?.name}
                    helperText={
                      formik1?.errors?.name &&
                      formik1?.touched?.name &&
                      formik1?.errors?.name
                    }
                  />
                </div>
              </Grid>
            </div>
            <div className={classes.fieldContainer}>
              <Grid item xs={12} sm={6}>
                <div className={classes.rightMargin}>
                  <TextField
                    name="email"
                    id="email"
                    value={formik1?.values?.email}
                    onChange={formik1?.handleChange}
                    type={"text"}
                    fullWidth
                    variant="outlined"
                    size="small"
                    label="Email"
                    error={formik1?.errors?.email && formik1?.touched?.email}
                    helperText={
                      formik1?.errors?.email &&
                      formik1?.touched?.email &&
                      formik1?.errors?.email
                    }
                  />
                </div>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className={classes.padding}>
                  <TextField
                    name="mobileNo"
                    id="mobileNo"
                    value={formik1?.values?.mobileNo}
                    onChange={formik1?.handleChange}
                    type={"text"}
                    fullWidth
                    variant="outlined"
                    size="small"
                    label="Mobile No*"
                    error={
                      formik1?.errors?.mobileNo && formik1?.touched?.mobileNo
                    }
                    helperText={
                      formik1?.errors?.mobileNo &&
                      formik1?.touched?.mobileNo &&
                      formik1?.errors?.mobileNo
                    }
                  />
                </div>
              </Grid>
            </div>
            <div className={classes.btnWrapper}>
              <Button variant="contained" onClick={formik1?.handleSubmit}>
                Update
              </Button>
            </div>
          </section>
        </Grid>
        <Grid item xs={12}>
          <section className={classes.container}>
            <div className={classes.heading}>
              <Typography variant="h5">Change your password</Typography>
            </div>
            <div className={classes.fieldContainer}>
      <Grid item xs={12} sm={6}>
        <div className={classes.rightMargin}>
          <TextField
            name="newPassword"
            id="newPassword"
            autoComplete="new-password"
            value={formik2?.values?.newPassword}
            onChange={formik2?.handleChange}
            type={showNewPassword ? "text" : "password"} // Toggle password visibility
            fullWidth
            variant="outlined"
            size="small"
            label="New Password*"
            error={formik2?.errors?.newPassword && formik2?.touched?.newPassword}
            helperText={
              formik2?.errors?.newPassword &&
              formik2?.touched?.newPassword &&
              formik2?.errors?.newPassword
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle new password visibility"
                    onClick={handleToggleNewPasswordVisibility}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </Grid>

      <Grid item xs={12} sm={6}>
        <div className={classes.padding}>
          <TextField
            name="confirmPassword"
            id="confirmPassword"
            autoComplete="confirm-password"
            value={formik2?.values?.confirmPassword}
            onChange={(e) => {
              formik2.handleChange(e);
              formik2.validateField("confirmPassword"); // Validate dynamically on each keystroke
            }}
            type={showConfirmPassword ? "text" : "password"} // Toggle password visibility
            fullWidth
            variant="outlined"
            size="small"
            label="Confirm Password*"
            error={
              formik2?.errors?.confirmPassword && formik2?.touched?.confirmPassword
            }
            helperText={
              formik2?.errors?.confirmPassword &&
              formik2?.touched?.confirmPassword &&
              formik2?.errors?.confirmPassword
            }
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle confirm password visibility"
                    onClick={handleToggleConfirmPasswordVisibility}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
      </Grid>
            </div>
            <div className={classes.btnWrapper}>
              <Button variant="contained" onClick={formik2?.handleSubmit}>
                Update
              </Button>
            </div>
          </section>
        </Grid>
      </Grid>
       
    </>
  );
};

export default ProfileSettings;
